import React from "react";
import {
  LimitedMarkdownRenderer,
  MarkdownSyntaxHighlighter,
} from "../MarkdownSyntaxHighlighter";
import { UserMessageText, UserMessageContainer } from "./styles";
import { getFormattedMessageText } from "./helpers";
import { useAuthStore } from "@store/auth.store";

type Props = {
  id: string;
  text: string;
  authorName: string;
  type: string;
};

export const UserMessage = React.forwardRef<HTMLDivElement, Props>(
  ({ id, text, type }, ref) => {
    const preferences = useAuthStore((state) => state.preferences);
    const formattedText = getFormattedMessageText(text, type);

    return (
      <UserMessageContainer
        key={id}
        ref={ref}
        data-message-id={`user-message-${id}`}
      >
        <UserMessageText>
          {preferences.renderMarkdownOnUserMessage ? (
            <MarkdownSyntaxHighlighter text={formattedText} />
          ) : (
            <LimitedMarkdownRenderer text={formattedText} />
          )}
        </UserMessageText>
      </UserMessageContainer>
    );
  },
);

UserMessage.displayName = "UserMessage";
